import React, {Component} from "react" ;
import {VirtualHost} from "../../constants";
import Pagination from "rc-pagination";
import Select from "rc-select";
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';
import locale from 'rc-pagination/lib/locale/tr_TR';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {direction: undefined, accessor: undefined};
        this.orderBy = this.orderBy.bind(this);
        this.onShowSizeChange = this.onShowSizeChange.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onShowSizeChange(current, pageSize) {
        if (isNaN(pageSize)) {
            current = 1;
            pageSize = this.props.total;
        }
        this.props.pageSize(current - 1, pageSize);
    }

    onChange(current, pageSize) {
        this.props.pageSize(current - 1, pageSize);
    }

    orderBy(direction, accessor) {
        this.setState({direction: direction, accessor: accessor});
        this.props.orderBy(accessor, direction);
    }

    render() {

        const source = VirtualHost.conf.resourcePrefix;
        return (
            <thead>
            {(this.props.hide && this.props.topPagination) &&
            <td colSpan={this.props.length}>
                <div className="col-sm-12 row" style={{justifyContent: "center"}}>
                    <div className="col-sm-2"></div>
                    <div style={{marginTop: '-10px'}}>
                        <Pagination
                            selectComponentClass={Select}
                            showSizeChanger
                            showQuickJumper={true}
                            showPrevNextJumpers={true}
                            showTotal={(total) => `Kayıt Sayısı : ${total}`}
                            defaultPageSize={this.props.size}
                            hideOnSinglePage={!this.props.hide}
                            pageSizeOptions={this.props.options}
                            pageSize={this.props.size}
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.onChange}
                            total={this.props.total}
                            className='pagi'
                            locale={locale}
                            showTitle={false}
                            current={this.props.page + 1}
                            showLessItems
                        />
                    </div>
                    <div className="col-sm-2"></div>
                </div>
            </td>
            }
            <tr>
                {
                    this.props.columns.map((column, j) =>
                        <th scope="col" key={j} width={column.width}>
                            {typeof column.accessor === "string" &&
                            <div className="durumaGore">
                                <button className={'tableBtn'}>
                                    {column.Header}
                                    {(column.sortable || column.sortable === undefined) && (
                                        <div className="konum">
                                            {this.state.accessor !== column.accessor &&
                                            <i style={{padding: '3px'}}
                                               onClick={(e) => this.orderBy("asc", column.accessor)}
                                               className="konum fas fa-caret-up arrows-1_minimal-right"/>
                                            }
                                            {this.state.accessor !== column.accessor &&
                                            <i style={{padding: '3px'}}
                                               onClick={(e) => this.orderBy("desc", column.accessor)}
                                               className="konum fas fa-caret-down arrows-1_minimal-right"/>
                                            }
                                            {this.state.accessor === column.accessor && this.state.direction === "asc" &&
                                            <i style={{padding: '3px'}}
                                               onClick={(e) => this.orderBy("desc", column.accessor)}
                                               className="konum fas fa-caret-up arrows-1_minimal-right"/>
                                            }
                                            {this.state.accessor === column.accessor && this.state.direction === "desc" &&
                                            <i style={{padding: '3px'}}
                                               onClick={(e) => this.orderBy("asc", column.accessor)}
                                               className="konum fas fa-caret-down arrows-1_minimal-right"/>

                                            }
                                        </div>)
                                    }
                                </button>
                            </div>
                            }
                            {column.accessor instanceof Array &&
                            column.accessor.map((data, k) =>
                                <span style={{padding: '0px'}} key={k}>
											<div className="durumaGore" style={{padding: '0px'}}>
												<button className={'tableBtn'}>
													{data.Header}
                                                    {(data.sortable || data.sortable === undefined) &&
                                                    (<div className="konum">
                                                        {this.state.accessor !== data.accessor &&
                                                        <i style={{padding: '3px'}}
                                                           onClick={(e) => this.orderBy("asc", data.accessor)}
                                                           className="konum fas fa-caret-up arrows-1_minimal-right"/>
                                                        }
                                                        {this.state.accessor !== data.accessor &&
                                                        <i style={{padding: '3px'}}
                                                           onClick={(e) => this.orderBy("desc", data.accessor)}
                                                           className="konum fas fa-caret-down arrows-1_minimal-right"/>
                                                        }
                                                        {this.state.accessor === data.accessor && this.state.direction === "asc" &&
                                                        <i style={{padding: '3px'}}
                                                           onClick={(e) => this.orderBy("desc", data.accessor)}
                                                           className="konum fas fa-caret-up arrows-1_minimal-right"/>
                                                        }
                                                        {this.state.accessor === data.accessor && this.state.direction === "desc" &&
                                                        <i style={{padding: '3px'}}
                                                           onClick={(e) => this.orderBy("asc", data.accessor)}
                                                           className="konum fas fa-caret-down arrows-1_minimal-right"/>
                                                        }
                                                    </div>)
                                                    }
												</button>
											</div>
                                    {k + 1 < column.accessor.length &&
                                    <hr/>
                                    }
										</span>
                            )
                            }
                        </th>
                    )
                }
            </tr>
            </thead>
        );
    }
}

export default Header;